"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDafDirectUrl = void 0;
const buildDafDirectUrl = ({ provider, amount, ein, legalName, reference, }) => {
    if (!provider.dafDirect) {
        return provider.portalUrl ?? null;
    }
    const designation = `${reference} — ${legalName}`.replace(/\|/g, " ").slice(0, 200);
    const parameters = {
        Npo_Id: ein.replace(/\D/g, ""),
        Grnt_Amnt: (amount / 100).toFixed(2),
        Grnt_Dsg_Txt: designation,
        Device_Type: "Widget",
        App_Id: "MDNR",
        source: "widget",
    };
    // DAFDirect encodes Schwab's grant parameters in a pipe-delimited PARMS value.
    if (provider.dafDirect === "dafgiving360") {
        const url = new URL("https://client.schwab.com/Areas/Access/Login");
        url.searchParams.set("KC", "Y");
        url.searchParams.set("cgift", "y");
        url.searchParams.set("SANC", "recommendgrant");
        url.searchParams.set("PARMS", `|${Object.entries(parameters)
            .map(([key, value]) => `${key}=${value}`)
            .join("|")}`);
        return url.toString();
    }
    const url = new URL(provider.dafDirect === "fidelity"
        ? "https://charitablegift.fidelity.com/cgfweb/CGFLogon.cgfdo"
        : "https://bnycharitable.org/bny/API/Grants.mvc.axd/DafDirect");
    for (const [key, value] of Object.entries(parameters)) {
        url.searchParams.set(key, value);
    }
    return url.toString();
};
exports.buildDafDirectUrl = buildDafDirectUrl;
